<template lang="html">
  <section class="landing row"> 
    <table  class="col-lg-12" v-if="!showModels">
      <th class="th-center" v-for="(region, index) in regions" :key="region.label">
        <span class="clickable" @click="showCountry(region.countryList, index)">{{region.label}}</span>
      </th>
      <tr><td><span class="line">&nbsp;</span></td></tr>
      <tr v-if="showCountries" v-for="country in countries" :key="country.id">      
        <td v-for="i in tableIndex" :key="i"></td>
        <td class="hovered clickable" style="border:solid 1px #B6B6B6;"  @click="showRange(country)"><span class="col-lg-12 th-center">{{country.description}}</span></td>
      </tr>
    </table>   
    <template v-else>
      <b-row class="col-lg-12">
        <span class="col-lg-3">
          <b-button variant="primary" @click="showModels=false"><i class="mdi mdi-arrow-left"></i>Back</b-button>
          <b-button variant="primary ml-10" @click="saveAll"><i class="mdi mdi-content-save"></i>Save</b-button>
        </span>
        <span class="col-lg-6"></span>
        <span class="col-lg-3"><b>Current country: </b>{{countrySelected.description}}</span>
      </b-row>
      <hr class="col-lg-12">
      <b-row id="LandingRow" class="col-lg-12">
       <table class="col-lg-12 LandingTable">
          <thead>
            <tr>
              <th class="sticky" v-for="family in families" :key="family.code">{{ family.description }}</th>
            </tr>
          </thead>
          <tbody>
            <tr><td><span class="line">&nbsp;</span></td></tr>
            <tr v-for="i in maxModelsInFamily" :key="i + 'family'">
              <td :class="i - 1 < family.models.length ? 'hovered' : ''" style="border:solid 1px #B6B6B6" v-for="family in families" :key="family.code + 'inner'">
                <div v-if="i - 1 < family.models.length" class="cell-model">
                  <b>{{ family.models[i - 1].modelDescription + " " + family.models[i - 1].model.modelYear }}</b><br/>
                  {{ "Modelcode: " + family.models[i - 1].code }} <br />
                  {{ "Vetele: " + family.models[i - 1].model.vetele }}
                  <div>
                    <b-button :class="'btn-' + (family.models[i - 1].showCCFE ? 'green' : 'gray')" @click="family.models[i - 1].showCCFE = !family.models[i - 1].showCCFE">
                      <i :class="'mdi mdi-' + (family.models[i - 1].showCCFE ? 'check' : 'close') + '-outline'">CCFE</i>
                    </b-button>
                    <b-button :class="'btn-' + (family.models[i - 1].showMXE ? 'green' : 'gray')" @click="family.models[i - 1].showMXE = !family.models[i - 1].showMXE">
                      <i :class="'mdi mdi-' + (family.models[i - 1].showMXE ? 'check' : 'close') + '-outline'">MXE</i>
                    </b-button>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </b-row>
    </template>
  </section>
</template>
<script lang="js">
import { mapActions, mapGetters } from "vuex"
export default {
  name: 'landing',
  methods: {
    showCountry(countryList, index){
      this.tableIndex = index;
      this.countries = countryList;
      this.showCountries=true;
    },
    showRange(country) {
      this.setSpinnerStatus(true);
      this.showModels = true;
      this.countrySelected = country;
      this.axios
        .get('/ccb/auth/fe/landing/getCountryRange/'+country.id, this.authHeader)
          .then((response) => {
            this.families = response.data;
            this.maxModelsInFamily = 0;
            this.families.forEach(family => {
              this.maxModelsInFamily = Math.max(this.maxModelsInFamily, family.models.length);
            });
          })
          .finally(() => this.setSpinnerStatus(false));
    },
    search() {
      this.setSpinnerStatus(true);
      this.axios
        .get('/ccb/auth/fe/landing/getLandingGeoRegion', this.authHeader)
          .then((response) => {
            this.regions = response.data;
          })
          .finally(() => this.setSpinnerStatus(false));
    },
    saveAll() {
      var insertUser, items = [];
      if(this.getCurUser.userAliasFromModis)
        insertUser = this.getCurUser.userAliasFromModis;
      else
        insertUser = this.getCurUser.username;
      
      this.families.forEach(family => {
        family.models.forEach(model => {
          if(model.showCCFE != model.countryModel.commModelFrontendActiveInCountry || model.showMXE != model.countryModel.mxeActive) {
            console.log("Updating model:", model);
            items.push({
              ...model.countryModel,
              insertUser: insertUser,
              showCCFEModified: model.showCCFE != model.countryModel.commModelFrontendActiveInCountry,
              showMXEModified: model.showMXE != model.countryModel.mxeActive,
              commModelFrontendActiveInCountry: model.showCCFE,
              mxeActive: model.showMXE
            });
          }
        });
      });
      this.setSpinnerStatus(true);
      this.axios.put('/ccb/auth/api/countryModel/'+this.countrySelected.id, items, this.authHeader)              
        .then(response => {
          this.$bvModal.msgBoxOk("Updated!", {
            okVariant: 'success',
            hideHeaderClose: false,
            centered: true
          }).then(() => {
            this.showRange(this.countrySelected);
          });
        })
        .catch(error => {
          this.$bvModal.msgBoxOk(error.message, {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
        })
        .finally(() => this.setSpinnerStatus(false));
    },
    ...mapActions([
      'setCurApp',
      'setLastSearch',
      'setSpinnerStatus'
    ])
  },
  data () {
    return {
      showCountries: false,
      showModels: false,
      regions : [],
      countries : [],
      countrySelected:null,
      tableIndex:0,
      families: [],
      maxModelsInFamily:0
    }
  },
  computed: {
    ...mapGetters([
      'authHeader',
      'getCurUser'
    ])
  },
  mounted() {
    window.scoper = this
    this.search();
    this.setCurApp('landing');
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
.line {
  min-height: 6px;
  display: block;
}
.collapse {
  border: 1px solid $gray-lightest;
  border-radius: 0.25rem;
}
.ml-10 {
  margin-left: 10px;
}
.btn-green {
  background-color: green;
  color: white;
  margin: 2px;
  font-size: small;
}
.btn-gray {
  background-color: gray;
  color: white;
  margin: 2px;
  font-size: small;
}
.cell-model {
  margin: 5px;
  line-height: 1.5;
  width: 14rem;
}
.landing {
  overflow: hidden;
}
.th-center {
  text-align: center;
}
.hovered:hover{
  background-color: darkgray;
}
#LandingRow.row {
  margin-left: 0;
  margin-right: 0;
  max-height: calc(100vh - #{$navbar-height} - 35px - 55px - 24px - 2rem);
  overflow: auto;
}
.LandingTable {
  border-collapse: separate;
  border-spacing: 0;
}
.sticky {
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: $white-smoke;
}
.landing table th span {
  width: 100%;
  display: block;
  cursor: pointer;
  transition: all .2s ease-out; 
  padding: 5px;
}

.landing table th span:hover {
  background: #c2c2c2;
}
</style>